/**
 * Draw a status message on a canvas (used for loading, error, and select states)
 * @param {CanvasRenderingContext2D} ctx - Canvas context
 * @param {number} width - Width of the area to draw in
 * @param {number} height - Height of the area to draw in
 * @param {string} message - Text to display
 * @param {string} backgroundColor - Background fill color
 */
export function drawStatusMessage(ctx, width, height, message, backgroundColor = '#222') {
  ctx.fillStyle = backgroundColor;
  ctx.fillRect(0, 0, width, height);
  ctx.fillStyle = '#fff';
  ctx.font = `${Math.floor(Math.min(width, height) * 0.08)}px Arial`;
  ctx.textAlign = 'center';
  ctx.textBaseline = 'middle';
  ctx.fillText(message, width / 2, height / 2);
}
